import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import AlertMessage from "../../common/components/AlertMessage";
import Backdrop from "@mui/material/Backdrop";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { MdNotes } from "react-icons/md";
import * as APIService from "../../common/api/index.js";
import URL from "../../common/api/ConstantURL";
import * as Sentry from "@sentry/react";
import "../../styles/ResidentNotes.css";
import { getSessionContext } from "../../common/utils/sessionContext";

const ResidentNotes = () => {
  const navigate = useNavigate();
  const { residentId, residentName } = getSessionContext();

  const [clientNote, setClientNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertStatus, setAlertStatusBase] = useState("");

  const loadNotes = () => {
    setLoading(true);
    setClientNote("");
    APIService.getData(URL.getResidentNotes + "?clientId=" + residentId)
      .then((responseData) => {
        if (responseData?.status === "success") {
          const note = (responseData?.data?.note ?? "").toString().trim();
          setClientNote(note);
        } else {
          setAlertStatusBase({
            message: responseData?.message || "Failed to fetch notes",
            status: "400",
            origin: "center",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        Sentry.captureException(error);
        setLoading(false);
        setAlertStatusBase({
          message: "Error while fetching resident notes",
          status: "400",
          origin: "center",
        });
      });
  };

  useEffect(() => {
    loadNotes();
  }, []);

  return (
    <>
      <Header />

      <div className="home-container">
        <Backdrop open={loading} sx={{ color: "#ffba30", zIndex: 9999 }}>
          <img src={require("../../assets/btTree.png")} className="loading-img" alt="Loading" />
        </Backdrop>

        {alertStatus && <AlertMessage status={alertStatus.status} message={alertStatus.message} origin={alertStatus.origin} closeAlert={() => setAlertStatusBase("")} />}

        <div className="home-inner-container notes-page">
          <div className="heading vitals-heading">
            <IoChevronBackCircleSharp className="vitals-preview-header" onClick={() => navigate("/resident-home")} />
            <span className="notes-client-name">{residentName || "Notes"}</span>
            <span></span>
          </div>
          <div className="notes-container">
            <h2 className="notes-title">Notes</h2>

            {clientNote ? (
              <div className="notes-list">
                <div className="notes-card">
                  <div className="notes-card-accent" />
                  <div className="notes-card-text">{clientNote}</div>
                </div>
              </div>
            ) : (
              loading ? null : (
                <div className="notes-empty-state">
                  <MdNotes size={28} />
                  <p>No Notes Added Yet</p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResidentNotes;
